(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["livedata-football-scores-web-components"] = factory();
	else
		root["livedata-football-scores-web-components"] = factory();
})(self, () => {
return 